

import { Injectable, Inject } from '@angular/core';
import { Observable, of, combineLatest, onErrorResumeNext, Subject, throwError, observable } from 'rxjs';
import { catchError, debounceTime } from 'rxjs/operators';
// tslint:disable-next-line: max-line-length
import {
  DwMdFormActionHandler, DwMdFormActionState, DwMdFormActionResult, DwFormAction, DwSecuritySSOService, DwSecurityRepositoryServiceToken,
  DwSecurityRepositoryService, DwSecurityUserService, DwMdFormContextInfo, DwOrmDataService, DwOrmDataServiceToken, DwMdFormInitActionHandler,
  DwMdFormInitActionState, DwAction, DwFormActionConfig, DwActionType, DwFormActionConfigDefaultComponent, DwCacheService, DwButtonConfig,
  DwMessagingService, DwMessageSeverity
} from '@devwareapps/devware-cap';
import { map, flatMap, tap, delay } from 'rxjs/operators';
import { OperatorFunction } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AppMetaDataItemNames, PayJobChangeEntity } from 'src/app/meta-data/app-meta-data.service';
import { CodeValuePayJobChangeStatus } from '../../permits/meta-data/permits-meta-data.service';
import { ConfigService } from 'src/environments/environment';
import { FormGroup } from '@angular/forms';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';

@DwAction<DwFormActionConfig>({
  isGlobal: false,
  actionType: DwActionType.formAction,
  display: 'Approve',
  keyName: 'approve',
  actionMessage: 'Approving...',
  parentItemName: AppMetaDataItemNames.PayJobChange,
  configComponent: DwFormActionConfigDefaultComponent,
  defaultButtonConfig: {
    buttonText: 'Approve',
    buttonTitle: 'Approve',
    command: 'approve',
    iconClass: '',
    buttonClass: 'btn btn-success'
  },
  configData: {
    redirectAfter: true,
    actionMessage: 'Approving...',
  }
})
@Injectable({
  providedIn: 'root'
})
export class PayJobChangeApproveActionService implements DwMdFormActionHandler, DwMdFormInitActionHandler {

  constructor(
    protected msalHandler: DwSecuritySSOService,
    protected securityService: DwSecurityUserService,
    @Inject(DwSecurityRepositoryServiceToken) protected securityRepository: DwSecurityRepositoryService,
    @Inject(DwOrmDataServiceToken) protected ormDataService: DwOrmDataService,
    protected cacheService: DwCacheService,
    protected http: HttpClient,
    protected messageService: DwMessagingService) {
  }
  private calls: number = 0;
  private ceoUserId = 1543; /* Need to replace */
  protected static canApproveErr : string = null;
  protected static canRejectErr : string = null;
  protected _state: DwMdFormInitActionState = null;
  /**
   * Initialize the action to customize any config items
   * @param formInitActionState form state
   */

  initAction(formInitActionState: DwMdFormInitActionState) {
    this._state = formInitActionState;
  }

  handleAction(formActionState: DwMdFormActionState): Observable<DwMdFormActionResult> {
    const result: DwMdFormActionResult = {
      success: true,
      message: 'Approved!',
      returnAfter: true
    };
    const cannotApproveResult: DwMdFormActionResult = {
      success: false,
      message: 'This is not assigned to you!',
    };
    this.canAssess(true, formActionState).subscribe((ok : boolean) => {
      if (ok)
        PayJobChangeApproveActionService.canApproveErr = null;
      else
        return of(cannotApproveResult);
    });
    
    formActionState.formApi.patchFormData({ StatusCv: 159 })

    /* Speed-hack for Ceo since all back-end logic will allow him to approve. 
    *  Note: Even if someone hacks this, the back-end will still run all logic 
    *        and only net result would be the initial 'appearance' of success 
    *        when hacked by returning to grid sooner. */
    const wachterUser = new WachterUserExt(this.securityService.securityContext.ApplicationUser);
    const CurrentUserTrustId = wachterUser.trustUserId;
    const isCeo = CurrentUserTrustId === this.ceoUserId;

    const ob = formActionState.formApi
                  .saveData(false)
                  .pipe(flatMap(saveResult => !saveResult.success ? of(saveResult) : of(result)));

    return isCeo ? of({ success: true }).pipe(delay(5)) : ob;
  }

  private _popErr(msg : string, approve : boolean){
    const mode: string = approve ? 'Approve' : 'Reject';
    // this.messageService.showMessage({
    //   messageHeading: 'Cannot ' + mode,
    //   messageBody: msg,
    //   severity: DwMessageSeverity.warning
    // });
  }

  private _canAssessCall(approve : boolean, payJobChange: PayJobChangeEntity, cacheKey: string): Observable<boolean> {
    
    const url = ConfigService.config.apiRoot + '/payJobChange/canAssess';
    
    if (payJobChange.EmployeeEthos_UserId == null || payJobChange.PayJobChangeId == null) 
      return of(false);

    if ((typeof payJobChange.WagePercentChange !== "number" || payJobChange.WagePercentChange !== payJobChange.WagePercentChange) ||
         payJobChange.WagePercentChange?.toString().indexOf('%') > -1) 
        payJobChange.WagePercentChange = null;
    
    const callCount: number = this.calls;
    let canApproveObs: Observable<any> = this.http.post(url, payJobChange);
    const validOp : OperatorFunction<any, boolean> =
      map(resp => {
        const appMsg : string = resp.approve;
        const rejMsg : string = resp.reject;
        const errMsg : string = resp.err;
        const msg : string = errMsg ?? (approve ? appMsg : rejMsg) ?? '';
        console.debug('canAssess Call #' + callCount + ' returned from API');
        return this.eval(msg, approve);
      });
    const errOp : OperatorFunction<any, boolean> =
      catchError(err => {
        console.error(err.message);
        return of(this.eval(err.message, approve));
      });
    return canApproveObs.pipe(validOp, errOp);
  }
  private eval(msg : string, approve : boolean) : boolean {
    const rutRoh : boolean = (msg ?? '').length > 0; 
    const prev : string = approve ? PayJobChangeApproveActionService.canApproveErr : PayJobChangeApproveActionService.canRejectErr;
    if (rutRoh && prev !== msg)
      this._popErr(msg, approve);

    PayJobChangeApproveActionService.canApproveErr = (approve ? msg : null) ?? PayJobChangeApproveActionService.canApproveErr;
    PayJobChangeApproveActionService.canRejectErr = (approve ? null : msg) ?? PayJobChangeApproveActionService.canRejectErr;
    return !rutRoh;
  }

  private _canAssessInternalCacheable(approve: boolean, payJobChange: PayJobChangeEntity): Observable<boolean> {
    const mode : string = approve ? "Approve": "Reject";
    const cacheKey: string = payJobChange.PayJobChangeId ? "payJobChange-Assess" + mode + "-" + payJobChange.PayJobChangeId : null;

    this.calls++;
    const callCount: number = this.calls;

    const cacheInvalidationTopics: string[] = [];
    const cached: boolean = this.cacheService.has(cacheKey);
    console.debug('canApprove Call #' + callCount + ' requested ' + (cached ? '(from cache)' : '(from api)') + ' w/key ' + cacheKey);
    const cachedOk: Observable<boolean> = this.cacheService.get(cacheKey, this._canAssessCall(approve, payJobChange, cacheKey), 30000, cacheInvalidationTopics);
    return cachedOk;
  }

  /**
  * Determines if the user can approve/reject the request
  * @param formActionState form state
  */
  protected canAssess(approve: boolean, formActionState: DwMdFormActionState, buttonConfig: DwButtonConfig = null): Observable<boolean> {
    const wachterUser = new WachterUserExt(this.securityService.securityContext.ApplicationUser);
    const CurrentUserTrustId = wachterUser.trustUserId;
    const payJobChange: PayJobChangeEntity = formActionState.formApi.getFormData();
    if (ConfigService.config.features.paf.workflowPort === true){
      if (!payJobChange) //defaulting to hidden to be slightly more secure || (buttonConfig && buttonConfig.hidden === true))
        return of(false);
      return this._canAssessInternalCacheable(approve, payJobChange);
    }

    /* Rules for Approval */
    /* 1. If current user is CEO, then CAN approve. */
    const isCeo = CurrentUserTrustId === this.ceoUserId;
    if (isCeo) return of(true);

    /* 2. If PAF applies to the current user then can NOT approve. */
    const isForCurrentUser = payJobChange.EmployeeEthos_UserId === CurrentUserTrustId;
    if (isForCurrentUser) return of(false);

    /* 3. If current user is 'Exec Admin' and state is Pending Exec then CAN approve */
    const isExecAdminCeo = wachterUser.hasPermission(AppPermissions.payJobChangeApproveOnBehalfOfExecutive);
    const isPendingExec = payJobChange.StatusCv === CodeValuePayJobChangeStatus.PendingExecutiveApproval;
    if (isExecAdminCeo && isPendingExec) return of(true);

    /* 4. If the PAF is ASSIGNED to the current user then CAN approve. */
    const isAssignedToCurrentUser = payJobChange.StatusAssignedToEthos_UserId === CurrentUserTrustId;
    if (isAssignedToCurrentUser) return of(true);

    /* 5. If current user has "Approve All" perm and state is NOT Pending exec, then CAN approve. */
    const hasApproveAll = wachterUser.hasPermission(AppPermissions.payJobChangeApproveAll);
    if (hasApproveAll && !isPendingExec) return of(true);

    /* 6. If all else false then can NOT approve */
    return of(false);
  }


  protected isApproved(formActionState: DwMdFormActionState): boolean {
    const payJobChange: PayJobChangeEntity = formActionState.formApi.getFormData();

    if (payJobChange && (payJobChange.StatusCv === 159 || payJobChange.StatusCv === 158)) {
      return true;
    }

    return false;
  }

}
